import aircoreColor from './assets/aircore-logo.svg';
import * as aircoreMedia from '@aircore/aircore-media';
import {AppConfigPanel} from './app-config-panel';

export function Header() {
  return (
    <div className="border-b-2 border-white bg-gradient-to-r from-indigo-400 via-purple-400 to-pink-400 w-full h-[65px] sticky top-0 left-0 right-0 mb-2">
      <div className="mx-2 pt-2 w-full flex items-top gap-2">
        <img
          className="h-12 w-12 rounded-sm p-1 border-2 border-black bg-white object-contain outline outline-1 outline-white md:h-16 md:w-16 md:outline-2"
          src={aircoreColor}
        />
        <div className="flex flex-col">
          <p className=" text-gray-700 font-bold italic text-lg">Aircore Pine Ridge</p>
          <p className=" text-gray-700 text-sm">
            BigSur: <b>{aircoreMedia.Engine.frameworkVersion}</b>
          </p>
        </div>
        <div className="absolute right-5">
          <AppConfigPanel />
        </div>
      </div>
    </div>
  );
}
